import request from '../utils/request';
import { buildApiPayload } from '../utils/api';

export function getAuditLog(params, signal) {
  return request({
    url: '/auditTrail',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}
